/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const web_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M23.25 12c0 6.213-5.037 11.25-11.25 11.25S.75 18.213.75 12m22.5 0C23.25 5.787 18.213.75 12 .75S.75 5.787.75 12m22.5 0H.75m8.539 10.921C7.767 20.689 6.75 16.633 6.75 12c0-4.633 1.017-8.689 2.539-10.921M2.482 18h19.036M2.482 6h19.036m-6.807-4.921C16.233 3.311 17.25 7.367 17.25 12c0 4.633-1.017 8.689-2.539 10.921"
    />
  </svg>
)
export default web_medium
